import axios from "axios";
import { BASE_URL, SPREMIUM_BASE_URL } from "../utils/constants";

const defaultOptions = (url, isFormData = false, noTimeout = false) => ({
  timeout: noTimeout ? 0 : 30000,
  baseURL: `${url}`,
  headers: {
    "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  },
});

const blobOptions = (url, isFormData = false, noTimeout = false) => ({
  timeout: noTimeout ? 0 : 30000,
  baseURL: `${url}`,
  responseType: "arraybuffer",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/pdf",
  },
});

export const ApiService = axios.create(defaultOptions(BASE_URL));

export const BlobApiService = axios.create(blobOptions(BASE_URL, false, true));

const getToken = () => `Bearer ${localStorage.getItem("adminToken")}`;
export const AuthorizedApiService = axios.create(defaultOptions(BASE_URL));
export const AuthorizedFormApiService = axios.create(
  defaultOptions(BASE_URL, true, false)
);
export const AuthorizedNoTimeOutApiService = axios.create(
  defaultOptions(BASE_URL, false, true)
);

const getSPremiumToken = () =>
  `Bearer ${localStorage.getItem("spremiumAuthToken")}`;
export const SPremiumAuthorizedApiService = axios.create(
  defaultOptions(SPREMIUM_BASE_URL)
);
export const SPremiumAuthorizedFormApiService = axios.create(
  defaultOptions(SPREMIUM_BASE_URL, true, false)
);

AuthorizedApiService.interceptors.request.use((req) => {
  req.headers.Authorization = getToken();
  return req;
});
AuthorizedApiService.interceptors.response.use(
  (res) => res,
  (err) => err
);

AuthorizedFormApiService.interceptors.request.use((req) => {
  req.headers.Authorization = getToken();
  return req;
});
AuthorizedFormApiService.interceptors.response.use(
  (res) => res,
  (err) => err
);

AuthorizedNoTimeOutApiService.interceptors.request.use((req) => {
  req.headers.Authorization = getToken();
  return req;
});
AuthorizedNoTimeOutApiService.interceptors.response.use(
  (res) => res,
  (err) => err
);

BlobApiService.interceptors.request.use((req) => {
  req.headers.Authorization = getToken();
  return req;
});
BlobApiService.interceptors.response.use(
  (res) => res,
  (err) => err
);

SPremiumAuthorizedApiService.interceptors.request.use((req) => {
  req.headers.Authorization = getSPremiumToken();
  return req;
});
SPremiumAuthorizedApiService.interceptors.response.use(
  (res) => res,
  (err) => err
);

SPremiumAuthorizedFormApiService.interceptors.request.use((req) => {
  req.headers.Authorization = getSPremiumToken();
  return req;
});
SPremiumAuthorizedFormApiService.interceptors.response.use(
  (res) => res,
  (err) => err
);
